import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

const DownloadPage = lazy(() => import('@/pages/DownloadPage'));

export const downloadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/download',
  component: DownloadPage,
});

export const Route = downloadRoute;
